export default "__VITE_ASSET__biqXaBKg__"